// Import model
import { DataviewAiAssistantResponse } from '../models/DataviewAiAssistantResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { AiAssistant } from '../models/AiAssistant';
import { DataView } from '../models/DataView';
import { FilterAiAssistantRequest } from '../models/FilterAiAssistantRequest';

// Import dependency serializers (for complex types)
import { AiAssistantSerializer } from './AiAssistantSerializer';
import { DataViewSerializer } from './DataViewSerializer';
import { FilterAiAssistantRequestSerializer } from './FilterAiAssistantRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewAiAssistantResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewAiAssistantResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewAiAssistantResponse instance
   */
  static deserialize(json: string): DataviewAiAssistantResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewAiAssistantResponse instance
   */
  static fromObject(obj: any): DataviewAiAssistantResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewAiAssistantResponse');
    }


    const instance: DataviewAiAssistantResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        AiAssistantSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterAiAssistantRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewAiAssistantResponse instances
   */
  static deserializeArray(json: string): DataviewAiAssistantResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewAiAssistantResponse instance to a JSON string
   */
  static serialize(instance: DataviewAiAssistantResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewAiAssistantResponse instance to a plain object
   */
  static toObject(instance: DataviewAiAssistantResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        AiAssistantSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterAiAssistantRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewAiAssistantResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewAiAssistantResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
